import { PhoneInput } from '@/components/ui/phone-input';
import { IS_PATIENT_CONTEXT_AUTO_EXTRACT_ENABLED } from '@/features/flags/legacy-flags';
import { ACCENT_VALUES, accentMessages } from '@/features/shadowHeidi/research-options';
import { useQueryInputSupportedLanguages } from '@/hooks/query/useQuerySupportedLanguages';
import { getLocalizedLanguageName } from '@/utils/languageSearch';
import {
  type PatientContextFieldsHost,
  type PatientContextPhoneInputProps,
} from '@heidi/patients';
import { useQueryUser } from '@heidi/workspace/data';

/** The practice country the phone field selects off the current user. */
export function useDefaultPhoneCountry() {
  const { data: user } = useQueryUser((data) => data?.practice_country ?? undefined);
  return user ?? undefined;
}

/** Binds the form-field surface to the app implementations it renders. */
export function usePatientContextFieldsHost(): PatientContextFieldsHost {
  return {
    PhoneInput,
    isAutoExtractEnabled: IS_PATIENT_CONTEXT_AUTO_EXTRACT_ENABLED,
    accentValues: ACCENT_VALUES,
    accentMessages,
    useSupportedLanguages: useQueryInputSupportedLanguages,
    getLocalizedLanguageName,
    useDefaultPhoneCountry,
  };
}

export type { PatientContextPhoneInputProps };
